import api from "../store/services/api";

export const getTables = (params) => api.get("/pos/saloon/table/", { params });

export const createTable = () =>
  api.post(
    "/pos/saloon/table/",
    {},
    {
      headers: { "Content-Type": "application/json" },
    }
  );

export const deleteTable = (tableId) =>
  api.delete(`/pos/saloon/table/?tid=${tableId}`);

const TablesService = {
  getTables,
  createTable,
  deleteTable,
};

export default TablesService;
